(function () {
    'use strict';

    angular
        .module('statistics')
        .controller('StatisticsFormController', StatisticsFormController)

    StatisticsFormController.$inject = ['$uibModal', 'StatisticsService', 'virtualfair', '$uibModalInstance', 'toastr'];


    function StatisticsFormController($uibModal, StatisticsService, virtualfair, $uibModalInstance, toastr) {
        var vm = this;

        vm.notificationDefault = {
            eventId: virtualfair,
            target: 'all',
            exhibitorId: null,
            content: ''
        }
        vm.notification = vm.notificationDefault

        vm.ok   = sendNotification
        vm.cancel = hideModal
        vm.targetOptions = [
            {id: 'visitor', name: 'Visitor'},
            {id: 'all', name: 'All'},
            {id: 'representative', name: 'Representative'},
            {id: 'representativeExhibitor', name: 'Exhibitor'}
        ]

        vm.exhibitors = []

        vm.ckeditorOptions = {
            language: "en",
            allowedContent: true,
            entities: false,
            linkShowTargetTab: false,
            toolbar: [
                [ 'Link' ]
            ]
        };

        function activate() {
            getExhibitors()
            removeLinkOptions()
        }

        function getExhibitors(){
            return StatisticsService.getExhibitors(virtualfair).then(function(response){
                var ex =  response.data.length ? response.data.map(e => ({id: e.user_id, name: e.name})) : []
                vm.exhibitors = ex;
            })
        }

        function sendNotification(){
            console.log('Sending notification')
            console.log(vm.notification)
            StatisticsService.sendNotification(vm.notification).then(function(response){
                console.log(response.data);
                toastr.success('Notification was sent')
            }).catch(function(err){
                toastr.error(err.data.message)
            }).finally(function(){
                $uibModalInstance.close();
            })
        }

        function hideModal() {
            $uibModalInstance.close();
        } 

        function removeLinkOptions(){
            CKEDITOR.on('dialogDefinition', function (ev) {
                var dialogName = ev.data.name
                var dialogDefinition = ev.data.definition
                if(dialogName === 'link'){
                    var infoTab = dialogDefinition.getContents( 'info' );
                    dialogDefinition.getContents('info').get('linkType').hidden = true;
                    dialogDefinition.getContents('info').get('protocol').hidden = true;
                    
                    console.log('PROTOCOL')
                    console.log(dialogDefinition.getContents('info').get('protocol'))
                }
            })
        }

        activate();
    }

})();